// PageLink.tsx

import React, { HTMLProps } from 'react';

export type Props = HTMLProps<HTMLAnchorElement> & { active?: boolean; nexts?: boolean };

export default function PageLink({
  className = '',
  active = false,
  disabled = false,
  children,
  nexts = false,
  ...otherProps
}: Props) {

  let customClassName = 'page-link';

  if (className) {
    customClassName += ` ${className}`;
  }

  if (active) {
    customClassName += ' active';
  }

  if (disabled) {
    customClassName += ' disabled';
  }

  if (nexts) {
    customClassName += ' nexts';
  }
  if (disabled) {
    return <span className={customClassName}>{children}</span>;
  }

  return (
    <a
      className={customClassName}
      aria-current={active ? 'page' : undefined}
      {...otherProps}
    >
      {children}
    </a>
  );
}
